import React from 'react';
import { Link } from 'react-router-dom';
import './GlobalHeader.css';

const GlobalHeader: React.FC = () => {
  return (
    <header className="global-header">
      <Link to="/">
        <div className="header-logo">
          <div className="header-logo-image-area"
            ><img src="/img/logo_white.png" alt="logo"  className="header-logo-image"/></div>
          <div className="header-logo-text-area">Rocinax Laboratory</div>
        </div>
      </Link>
    </header>
  );
}

export default GlobalHeader;